import { data as d1 } from "./json/g1_books";
import { data as d2 } from "./json/g2_books";
import { data as d3 } from "./json/g3_books";
import { data as d4 } from "./json/g4_books";
import { data as d5 } from "./json/g5_books";
import { data as d6 } from "./json/g6_books";
import { data as d7 } from "./json/g7_books";
import { data as d8 } from "./json/g8_books";

export const appType = "external"; // external, teacher
export const trialService = true; // 트라이얼 모드인지 여부

export const data = {
  appVer: "2.0.1",
  studybooks: [
    {
      category: "빨강",
      categoryKey: "c1",
      badge: "입문",
      desc: "중국어 발음 마스터(병음, 성조)",
      color: "#de524b",
      books: d1,
      //books: [],
    },
    {
      category: "주황",
      categoryKey: "c2",
      badge: "기초",
      desc: "자기소개, 핵심 문항별 학습",
      color: "#e7a500",
      books: d2,
      //books: [],
    },
    {
      category: "노랑",
      categoryKey: "c3",
      badge: "초급1",
      desc: "32가지 이야기 구성, 초급 회화 가능",
      color: "#edd200",
      //books: [],
      books: d3,
    },
    {
      category: "초록",
      categoryKey: "c4",
      badge: "중급1",
      desc: "기본어법의 문형별 학습",
      color: "#93bb00",
      //books: [],
      books: d4,
    },
    {
      category: "파랑",
      categoryKey: "c5",
      badge: "중급2",
      desc: "서술문과 회화문 학습, 다양한 표현 학습",
      color: "#7eabeb",
      //books: [],
      books: d5,
    },
    {
      category: "남색",
      categoryKey: "c6",
      badge: "고급1",
      desc: "토론 학습으로 종합적 사고 능력 향상",
      color: "#253a62",
      //books: [],
      books: d6,
    },
    {
      category: "보라",
      categoryKey: "c7",
      badge: "고급2",
      desc: "물건 구매하기, 생일, 장소 표현",
      color: "#aa5aef",
      //books: [],
      books: d7,
    },
    {
      category: "아이두",
      categoryKey: "c8",
      badge: "명작",
      desc: "중국어로 만나는 세계명작동화",
      color: "#cdcdab",
      //books: [],
      books: d8,
    },
  ],
};
